<template>
	<q-layout-drawer side="left" v-model="openMenu" v-if="$q.platform.is.mobile">
		<q-list no-border link inset-separator>
			<q-list-header>{{ $t('navigation') }}</q-list-header>

			<q-item :to="{ name: 'admin_overview' }">
				<q-item-side icon="far fa-tachometer-alt-slowest" />
				<q-item-main label="Visão Geral" />
			</q-item>

			<q-collapsible icon="far fa-book" :label="$t('registrations')" group="navigation"
				v-if="showUsers || showOrganization || showTags || showImport">
				<q-list link separator>
					<q-item v-for="(content, index) in users" :key="'ru' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showUsers">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>

					<q-item v-for="(content, index) in organization" :key="'ro' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showOrganization">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>

					<q-item v-for="(content, index) in tags" :key="'tt' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showTags">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>

					<q-item v-for="(content, index) in importUser" :key="'imp' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showImport">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>
				</q-list>
			</q-collapsible>

			<q-collapsible icon="far fa-graduation-cap" :label="$t('training')" group="navigation" v-if="showOnline ||
		showPresential ||
		showTrails ||
		showPodcasts ||
		showWebinars ||
		showLiveClasses
		">
				<q-list link separator>
					<q-item v-for="(content, index) in online" :key="'to' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showOnline">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>

					<q-item v-for="(content, index) in presential" :key="'tp' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showPresential">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>

					<q-item v-for="(content, index) in trails" :key="'tt' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showTrails">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>

					<q-item v-for="(content, index) in webinars" :key="'tw' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showWebinars">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>

					<q-item v-for="(content, index) in podcasts" :key="'tpp' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showPodcasts">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>

					<q-item v-for="(content, index) in liveClasses" :key="'lc' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showLiveClasses">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>
				</q-list>
			</q-collapsible>

			<q-collapsible icon="far fa-volume-up" :label="$t('communications')" group="navigation" v-if="showSurveys ||
		showMessages ||
		showNews ||
		showFaq ||
		showBanners ||
		showCalendar
		">
				<q-list link separator>
					<q-item v-for="(content, index) in surveys" :key="'cs' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showSurveys">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>

					<q-item v-for="(content, index) in messages" :key="'cm' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showMessages">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>

					<q-item v-for="(content, index) in news" :key="'cn' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showNews">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>

					<q-item v-for="(content, index) in faq" :key="'cf' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showFaq">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>

					<q-item v-for="(content, index) in banners" :key="'cb' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showBanners">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>

					<q-item v-for="(content, index) in calendar" :key="'cc' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showCalendar">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>
				</q-list>
			</q-collapsible>

			<q-collapsible icon="far fa-books" :label="$t('file')" group="navigation" v-if="showLibrarys">
				<q-list link separator>
					<q-item v-for="(content, index) in librarys" :key="'ruu' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showLibrarys">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>
				</q-list>
			</q-collapsible>

			<q-collapsible icon="far fa-door-open" :label="$t('4traders')" group="navigation" v-if="showFourTraders">
				<q-list link separator>
					<q-item v-for="(content, index) in fourtraders" :key="'ft' + index" :to="{ name: content.to }"
						v-if="showMenu(content.meta) && showFourTraders">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>
				</q-list>
			</q-collapsible>

			<q-collapsible icon="far fa-cog" :label="$t('configuration')" group="navigation" v-if="showLibrarys">
				<q-list link separator>
					<q-item v-for="(content, index) in configurations" :key="'cas' + index" :to="{ name: content.to }"
						v-if="content.hide !== true">
						<q-item-side :icon="content.icon" />
						<q-item-main :label="$t(content.text)" />
					</q-item>
				</q-list>
			</q-collapsible>
		</q-list>

		<q-list no-border link inset-separator>
			<q-list-header>{{ $t('others') }}</q-list-header>

			<q-item @click.native="goToHome()">
				<q-item-side icon="far fa-home" />
				<q-item-main :label="$t('home')" />
			</q-item>

			<q-collapsible icon="far fa-building" :label="getClientLabel" group="sidebar" v-model="show_clients"
				v-if="user_clients.length > 1">
				<q-list separator link>
					<q-item tag="label" v-for="(item, index) in user_clients" :key="index">
						<q-item-side>
							<q-radio v-model="selected_client" :val="item.id" />
						</q-item-side>
						<q-item-main>
							<q-item-tile label>{{ item.name }}</q-item-tile>
						</q-item-main>
					</q-item>
				</q-list>
			</q-collapsible>

			<q-item v-if="user_clients.length == 1">
				<q-item-side icon="far fa-building" />
				<q-item-main :label="getClientLabel" />
			</q-item>

			<q-collapsible icon="far fa-globe" :label="getCountryLabel" group="sidebar" v-model="show_countries"
				v-if="countries.length > 1">
				<q-list separator link>
					<q-item tag="label" v-for="(item, index) in countries" :key="index">
						<q-item-side>
							<q-radio v-model="selected_country" :val="item.id" />
						</q-item-side>
						<q-item-main>
							<q-item-tile label>{{ item.name }}</q-item-tile>
						</q-item-main>
					</q-item>
				</q-list>
			</q-collapsible>

			<q-item v-if="countries.length == 1">
				<q-item-side icon="far fa-globe" />
				<q-item-main :label="getCountryLabel" />
			</q-item>

			<q-collapsible icon="far fa-user-circle" :label="full_name" group="sidebar">
				<q-list separator link>
					<q-item @click.native="logout()">
						<q-item-side>
							<q-icon name="far fa-sign-out-alt" />
						</q-item-side>
						<q-item-main>
							<q-item-tile label>{{ $t('sign_out') }}</q-item-tile>
						</q-item-main>
					</q-item>
				</q-list>
			</q-collapsible>
		</q-list>
		<copyright />
	</q-layout-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import Copyright from 'components/Copyright'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'admin'] },

	components: {
		copyright: Copyright,
	},

	data() {
		return {
			countries: [],
			show_clients: false,
			show_countries: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			admin_left_menu: 'common/admin_left_menu',
			clients: 'params/clients',
			full_name: 'common/full_name',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_client_selected: 'common/id_user_client_selected',
			id_user_language_selected: 'common/id_user_language_selected',
			is_superuser: 'common/is_superuser',
			reload_content: 'common/reload_content',
			tmp_system_new_version: 'params/tmp_system_new_version',
			user_clients: 'common/user_clients',
			user_module_items: 'common/user_module_items',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		showHomeButton() {
			return !this.tmp_system_new_version
		},

		getCountryLabel() {
			const obj = this.countries.find((obj) => obj.id == this.id_user_client_country_selected)
			return obj ? obj.name : ''
		},

		getClientLabel() {
			const obj = this.user_clients.find((obj) => obj.id == this.id_user_client_selected)
			return obj ? obj.name : ''
		},

		selected_country: {
			get() {
				return this.id_user_client_country_selected
			},
			set(val) {
				this.$store.dispatch('common/SET_COUNTRY', [val])
				this.show_countries = !this.show_countries
				this.setUserSelection('country')
			},
		},

		selected_client: {
			get() {
				return this.id_user_client_selected
			},
			set(val) {
				this.$store.dispatch('common/SET_CLIENT', [val])
				this.show_clients = !this.show_clients
				this.getCountryList()
				this.setUserSelection('client')
			},
		},

		openMenu: {
			get() {
				return this.admin_left_menu
			},
			set() {
				this.$store.dispatch('common/SET_ADMIN_LEFT_MENU', [false])
			},
		},

		clientParams() {
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) return obj
			}
			return null
		},

		tags() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-hashtag',
						to: 'admin_tags',
						text: 'tags',
						meta: 'tags',
					})
				}
			}
			return contents
		},

		showTags() {
			let show = false

			this.tags.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		users() {
			const contents = []
			if (this.id_user_client_selected) {
				const obj = this.clients.find((obj) => obj.id === this.id_user_client_selected)
				if (obj) {
					contents.push(
						{
							icon: 'far fa-user',
							to: 'admin_users',
							text: 'users',
							meta: 'users',
						},
						{
							icon: 'far fa-users',
							to: 'admin_users_groups',
							text: 'users_groups',
							meta: 'users_groups',
						}
					)
				}
			}
			return contents
		},

		showUsers() {
			let show = false

			this.users.forEach((i) => {
				if (this.user_module_items) {
					const obj = this.user_module_items.find(
						(obj) => obj.slug === i.meta && obj.permission === true
					)
					if (obj) show = true
				}
			})
			return show
		},

		organization() {
			let contents = []
			if (this.id_user_client_selected) {
				const obj = this.clients.find((obj) => obj.id === this.id_user_client_selected)
				if (obj) {
					contents.push(
						{
							icon: 'far fa-city',
							to: 'admin_headquarters',
							text: 'headquarters',
							meta: 'headquarter',
						},
						{
							icon: 'far fa-building',
							to: 'admin_branches',
							text: 'branches',
							meta: 'branch',
						}
					)
				}
			}
			return contents
		},

		showOrganization() {
			let show = false

			this.organization.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		librarys() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj && obj.has_library) {
					contents.push({
						icon: 'far fa-list',
						to: 'admin_library_categories',
						text: 'library_categories',
						meta: 'library_categories',
					})

					contents.push({
						icon: 'far fa-books',
						to: 'admin_libraries',
						text: obj.title_library == '' ? 'library' : obj.title_library,
						meta: 'library',
					})
				}
			}
			return contents
		},

		showLibrarys() {
			let show = false
			this.librarys.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		online() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-graduation-cap',
						to: 'admin_trainings',
						text: obj.title_trainings == '' ? 'online' : obj.title_trainings,
						meta: 'trainings',
					})
				}
			}
			return contents
		},

		showOnline() {
			if (this.clientParams && this.clientParams.has_courses) {
				let show = false

				this.online.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		presential() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-clipboard-list-check',
							to: 'courses_catalog',
							text: 'courses_catalog',
							meta: 'presential_manager_catalog',
						},
						{
							icon: 'far fa-users-class',
							to: 'planned_vacancies',
							text: 'planned_vacancies',
							meta: 'presential_manager_seats',
						},
						{
							icon: 'far fa-list',
							to: 'appointments',
							text: 'appointments',
							meta: 'appointments',
						},
						{
							icon: 'far fa-calendar-alt',
							to: 'presential_calendar',
							text: 'calendar',
							meta: 'appointments',
						},
						{
							icon: 'far fa-calendar-star',
							to: 'appointment_types',
							text: 'appointment_types',
							meta: 'appointment_types',
						},
						{
							icon: 'far fa-boxes',
							to: 'product_categories',
							text: 'categories_modules',
							meta: 'product_categories',
						},
						{
							icon: 'far fa-box',
							to: 'products',
							text: 'products_themes',
							meta: 'products',
						},
						{
							icon: 'far fa-tools',
							to: 'support_materials',
							text: 'inputs',
							meta: 'support_materials',
						}
					)
				}
			}
			return contents
		},

		showPresential() {
			if (this.clientParams && this.clientParams.has_presential) {
				let show = false

				this.presential.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
					if (i.meta === 'presential_manager_catalog') {
						let client = this.clients.find((obj) => {
							return obj.id === this.id_user_client_selected
						})
						if (client.presential_event_catalog) show = true
					}
				})
				return show
			} else return false
		},

		trails() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-sign',
						to: 'admin_trails',
						text: obj.title_trails == '' ? 'trails' : obj.title_trails,
						meta: 'trails',
					})
				}
			}
			return contents
		},

		showTrails() {
			if (this.clientParams && this.clientParams.has_trails) {
				let show = false

				this.trails.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		podcasts() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-podcast',
						to: 'admin_podcasts',
						text: 'podcasts',
						meta: 'podcasts',
					})
				}
			}
			return contents
		},

		showPodcasts() {
			if (this.clientParams && this.clientParams.has_podcasts) {
				let show = false

				this.podcasts.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		webinars() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-broadcast-tower',
						to: 'admin_webcasts',
						text: obj.title_webcasts == '' ? 'webinars' : obj.title_webcasts,
						meta: 'webcasts',
					})
				}
			}
			return contents
		},

		showWebinars() {
			if (this.clientParams && this.clientParams.has_webcasts) {
				let show = false

				this.webinars.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		liveClasses() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'fal fa-chalkboard-teacher',
						meta: 'live_classes',
						text:
							obj.title_live_classes == '' ? 'live_classes' : obj.title_live_classes,
						to: 'admin_live_classes',
					})
				}
			}
			return contents
		},

		showLiveClasses() {
			if (this.clientParams && this.clientParams.has_live_classes) {
				let show = false

				this.liveClasses.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		fourtraders() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-list-alt',
							to: '4traders_questions',
							text: 'questions',
							meta: '4traders_questions',
						},
						{
							icon: 'far fa-tasks',
							to: '4traders_tasks',
							text: 'tasks',
							meta: '4traders_tasks',
						}
					)
				}
			}
			return contents
		},

		showFourTraders() {
			if (this.clientParams && this.clientParams.has_4traders) {
				let show = false

				this.fourtraders.forEach((i) => {
					if (this.user_module_items) {
						let obj = this.user_module_items.find((obj) => {
							return obj.slug === i.meta && obj.permission === true
						})
						if (obj) show = true
					}
				})
				return show
			} else return false
		},

		rewards() {
			const contents = []
			if (this.id_user_client_selected) {
				const obj = this.clients.find((obj) => obj.id === this.id_user_client_selected)
				if (obj) {
					contents.push({
						icon: 'far fa-calendar-alt',
						to: 'events',
						text: 'events',
						meta: 'events_qrcode',
					})
				}
			}
			return contents
		},

		surveys() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-poll-people',
						to: 'admin_surveys',
						text: 'surveys',
						meta: 'surveys',
					})
				}
			}
			return contents
		},

		showSurveys() {
			let show = false

			this.surveys.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		messages() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-comment',
						to: 'admin_messages',
						text: 'messages',
						meta: 'messages',
					})
				}
			}
			return contents
		},

		showMessages() {
			let show = false

			this.messages.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		news() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj && obj.has_news) {
					contents.push({
						icon: 'far fa-newspaper',
						to: 'admin_news',
						text: obj.title_news === '' ? 'news' : obj.title_news,
						meta: 'news',
					})
				}
			}
			return contents
		},

		showNews() {
			let show = false

			this.news.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		faq() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-question-circle',
							to: 'admin_faqs',
							text: obj.title_faq === '' ? 'faq' : obj.title_faq,
							meta: 'faq',
						},
						{
							icon: 'far fa-list',
							to: 'admin_faq_categories',
							text: 'faq_categories',
							meta: 'faq_categories',
						}
					)
				}
			}
			return contents
		},

		showFaq() {
			let show = false
			let hasFaq = false

			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					hasFaq = obj.has_faq
				}
			}

			this.faq.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj && hasFaq) show = true
				}
			})
			return show
		},

		banners() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-ad',
							to: 'admin_banners',
							text: 'banners',
							meta: 'banners',
						},
						{
							icon: 'far fa-sign-in',
							to: 'banners_welcome',
							text: 'banners_welcome',
							meta: 'banners_welcome',
						}
					)
				}
			}
			return contents
		},

		showBanners() {
			let show = false

			this.banners.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		calendar() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-calendar-alt',
						to: 'schedules',
						text: 'calendar',
						meta: 'calendar',
					})
				}
			}
			return contents
		},

		showCalendar() {
			let show = false

			this.calendar.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		importUser() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push({
						icon: 'far fa-cloud-upload',
						to: 'admin_imports',
						text: 'import',
						meta: 'admin_import',
					})
				}
			}
			return contents
		},

		showImport() {
			let show = false
			return this.user_module_items
			this.import.forEach((i) => {
				if (this.user_module_items) {
					let obj = this.user_module_items.find((obj) => {
						return obj.slug === i.meta && obj.permission === true
					})
					if (obj) show = true
				}
			})
			return show
		},

		communication() {
			let communication = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					communication.push({
						icon: 'far fa-poll-people',
						to: 'admin_surveys',
						text: 'surveys',
						meta: 'surveys',
					})
					communication.push({
						icon: 'far fa-comment',
						to: 'admin_messages',
						text: 'messages',
						meta: 'messages',
					})
					communication.push({
						icon: 'far fa-newspaper',
						to: 'admin_news',
						text: obj.title_news == '' ? 'news' : obj.title_news,
						meta: 'news',
					})
					communication.push({
						icon: 'far fa-question-circle',
						to: 'admin_faqs',
						text: obj.title_faq == '' ? 'faq' : obj.title_faq,
						meta: 'faq',
					})
					communication.push({
						icon: 'far fa-list',
						to: 'admin_faq_categories',
						text: 'faq_categories',
						meta: 'faq_categories',
					})
					communication.push({
						icon: 'far fa-ad',
						to: 'admin_banners',
						text: 'banners',
						meta: 'banners',
					})
					communication.push({
						icon: 'far fa-sign-in',
						to: 'banners_welcome',
						text: 'banners_welcome',
						meta: 'banners_welcome',
					})
				}
			}
			return communication
		},

		points_table() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-trophy',
							to: 'reward_sale_products',
							text: 'intel_product',
							meta: 'reward_sale_products',
						},
						{
							icon: 'far fa-tag',
							to: 'reward_brands',
							text: 'brands',
							meta: 'reward_brands',
						},
						{
							icon: 'far fa-box',
							to: 'reward_sale_product_types',
							text: 'product_type',
							meta: 'reward_sale_product_types',
						},
						{
							icon: 'far fa-camera',
							to: 'photo_types',
							text: 'photo_types',
							meta: 'reward_upload_file_types',
						}
					)
				}
			}
			return contents
		},

		showBadges() {
			let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			return client.has_badges ? client.has_badges : false
		},

		configurations() {
			let contents = []
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj) {
					contents.push(
						{
							icon: 'far fa-list-ul',
							to: 'admin_config',
							text: 'configuration',
							meta: 'configuration',
						},
						{
							icon: 'far fa-chalkboard',
							to: 'admin_about',
							text: 'about_the_company',
							meta: 'about',
						},
						{
							icon: 'far fa-clipboard-list-check',
							to: 'admin_terms',
							text: 'terms_and_conditions',
							meta: 'terms',
						},
						{
							icon: 'far fa-user-secret',
							to: 'admin_policy',
							text: 'privacy_policy',
							meta: 'policy',
						},
						{
							icon: 'far fa-cookie-bite',
							to: 'admin_cookies_policy',
							text: 'cookies_policy',
							meta: 'cookies_policy',
						},
						{
							icon: 'far fa-award',
							to: 'admin_badges',
							text: 'badges',
							meta: 'badges',
							hide: !this.showBadges
						},
						{
							icon: 'far fa-home',
							to: 'admin_home',
							text: 'home',
							meta: 'home',
						},
						{
							icon: 'far fa-window-restore',
							to: 'admin_wild_cards',
							text: 'Wild Cards',
							meta: 'wild_card',
						},
						{
							icon: 'far fa-file-upload',
							to: 'import_code',
							text: 'code_apple',
							meta: 'import_code',
						},
						{
							icon: 'far fa-globe',
							to: 'area_config',
							text: 'areas',
							meta: 'area_config',
						},
						{
							icon: 'far fa-mailbox',
							to: 'mailing_list_config',
							text: 'mailing_list',
							meta: 'mailing_list',
						}
					)
				}
			}
			return contents
		},
	},

	methods: {
		getCountryList() {
			this.countries = []

			if (this.user_clients) {
				let obj = this.user_clients.find((obj) => {
					return obj.id == this.id_user_client_selected
				})

				if (obj) {
					this.countries = obj.countries

					let obj_countries = this.countries.find((obj) => {
						return obj.id == this.id_user_client_country_selected
					})
					if (!obj_countries) {
						this.$store.dispatch('common/SET_COUNTRY', [this.countries[0].id])
						this.setUserSelection()
					}
				}
			}
		},

		logout() {
			this.openMenu = false
			this.$store.dispatch('common/SET_ACCESS_TOKEN', ['', '', ''])

			setTimeout(() => {
				this.$q.loading.hide()
				this.$router.replace({ name: 'login' })
			}, 700)
		},

		showMenuList(meta) {
			let obj = this.user_module_items.find((obj) => obj.slug === meta)
			return obj ? obj.permission : false
		},

		setUserSelection(origin) {
			this.$q.loading.show()

			let fd = new FormData()
			fd.append('client', this.id_user_client_selected)
			fd.append('country', this.id_user_client_country_selected)
			fd.append('language', this.id_user_language_selected)

			this.$axios
				.post('/accounts/set_user_selection/', fd, this.getHeader)
				.then(() => {
					this.getUserData()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		getUserData() {
			this.$axios
				.get('/accounts/read_user_data/', this.getHeader)
				.then((response) => {
					const d = response.data

					this.$store.dispatch('common/SET_USER_DATA', [
						d.id,
						d.id_user_client_profile,
						d.full_name,
						d.document,
						d.id_user_client_selected,
						d.id_user_client_country_selected,
						d.id_user_language_selected,
						d.user_clients,
						d.user_client_module_items,
						d.user_firebase_document,
						d.is_superuser,
						d.email,
						d.user_firebase_document_ranking_areas,
						d.has_mandatory_surveys,
						d.accept_terms_and_conditions,
						d.user_companies,
						d.user_branches,
					])

					if (this.$route.name == 'admin_overview') {
						this.$store.dispatch('common/SET_RELOAD_CONTENT', [!this.reload_content])
					} else {
						this.$router.push({ name: 'admin_overview' })
					}
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		goToHome() {
			if (this.showHomeButton) {
				let obj_redirect = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				if (obj_redirect) {
					if (obj_redirect.home_route)
						this.$router.replace({ name: obj_redirect.home_route })
					else {
						this.$router.replace({ name: 'courses' })
					}
				} else {
					this.$router.replace({ name: 'courses' })
				}
			} else {
				if (process.env.SITE_URL) {
					const hostname = new URL(process.env.CONTROL_PANNEL_URL).hostname
					const domainToCookie = hostname.substring(hostname.indexOf('.'))
					this.$q.loading.show()

					this.$axios.get(`/etraining_login/tswap/`, this.getHeader)
						.then(response => {

							document.cookie = `at-v2=${response.data.access_token}; path=/; domain=${domainToCookie}; SameSite=Lax; Secure`
							window.open(
								`${process.env.SITE_URL}/login-redirect-v2/`
							)
						})
						.catch(e => {
							if (e.response && e.response.status === 401) {
								this.$router.replace({ name: 'login' })
								return
							}

							window.open(
								`${process.env.SITE_URL}/`
							)
							console.log(e)
						})
						.finally(() => {
							this.$q.loading.hide()
						})
				}
			}
		},

		showMenu(meta) {
			if (meta === 'presential_manager_catalog') {
				let client = this.clients.find((obj) => {
					return obj.id === this.id_user_client_selected
				})
				return client.presential_event_catalog
			} else {
				const obj = this.user_module_items.find((obj) => obj.slug === meta)
				return obj ? obj.permission : false
			}
		},
	},

	created() {
		this.getCountryList()
	},
}
</script>

<style></style>
